export { default } from './IconButton';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/IconButton/index.js
// module id = 95
// module chunks = 2